/**
 * 图片预览器懒加载壳（任务 12c，VlistDemoLazy 同模式）：预览器本体
 * （手势/缩放/保存）动态 import，首屏 bundle 零增量。加载期间先渲染
 * 纯黑背景占位（点开即有全屏反馈，chunk 到位后无缝接管），可点击/Esc 取消。
 */
import { useLayoutEffect } from 'preact/hooks';
import { useLazyModule } from './useLazyModule';
import type { FunctionComponent } from 'preact';
import type { ImageViewerProps } from './ImageViewer';
import styles from './imageViewer.module.scss';

export function ImageViewerLazy(props: ImageViewerProps) {
  const { mod } = useLazyModule(() => import('./ImageViewer'));
  const Viewer: FunctionComponent<ImageViewerProps> | null = mod?.ImageViewer ?? null;

  const { onClose } = props;
  // 占位期也可退出（弱网 chunk 慢时不锁死用户）；本体挂载后由其自行监听
  useLayoutEffect(() => {
    if (Viewer !== null) return undefined;
    const onKey = (e: KeyboardEvent): void => {
      if (e.key === 'Escape') onClose();
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [Viewer, onClose]);

  if (Viewer === null) {
    return (
      <div className={styles.viewer} data-testid="image-viewer-loading" onClick={onClose}>
        <div className={styles.backdrop} />
      </div>
    );
  }
  return <Viewer {...props} />;
}
